import React from 'react'
import { Icon } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import './TabsCarousel.css'

class TabsCarousel extends React.Component {
	state = {
		currentItem: 0,
	}

	tabsPerPage = 4
	tabsPerMove = 1
	currentPosition = 0

	handleMove = dir => {
		const containerEl = this.refs['tabs-carousel-container']
		const containerWidth = containerEl.getBoundingClientRect().width
		const currentWidth = containerWidth / this.tabsPerPage * this.tabsPerMove

		if(dir === 'next' && !this.isLast()) {
			this.currentPosition -= currentWidth
			this.goNext()
		}

		if(dir === 'prev' && !this.isFirst()) {
			this.currentPosition += currentWidth
			this.goPrev()
		}
	}

	handleJump = idx => {
		const containerEl = this.refs['tabs-carousel-container']
		const containerWidth = containerEl.getBoundingClientRect().width
		const itemWidth = containerWidth / this.tabsPerPage

		this.currentPosition = -(idx * itemWidth)
		this.setState({ currentItem: idx })
		this.animate()
	}

	goPrev = () => {
		this.setState(prevState => ({ currentItem: prevState.currentItem - 1 }))
		this.animate()
	}

	goNext = () => {
		this.setState(prevState => ({ currentItem: prevState.currentItem + 1 }))
		this.animate()
	}

	animate = () => {
		const contentEl = this.refs['tabs-carousel-content']
		contentEl.style.transform = `translateX(${this.currentPosition}px)`
	}

	isFirst = () => this.state.currentItem === 0
	isLast = () => this.state.currentItem === this.props.tabs.length-1

	render() {
		return (
			<div className="Tabs-carousel">
				<div className="Tabs-carousel-wrapper">
					<div className="Tabs-carousel-container" ref="tabs-carousel-container">
						<div className="Tabs-carousel-content" ref="tabs-carousel-content">
						{this.props.tabs.map((item, idx) => (
							<a
								key={idx}
								onClick={() => this.handleJump(idx)}
								className={this.state.currentItem === idx ? 'is-active' : ''}
								style={{ flexBasis: `${100 / this.tabsPerPage}%` }}>
								{item}
							</a>
						))}
						</div>
					</div>
					<div className="Tabs-carousel-actions">
						{!this.isFirst() && <a onClick={() => this.handleMove('prev')} className="is-prev"><Icon name="chevron-left" /></a>}
						{!this.isLast() && <a onClick={() => this.handleMove('next')} className="is-next"><Icon name="chevron-right" /></a>}
					</div>
				</div>
				<div className="Tabs-carousel-slides">
					{React.Children.map(this.props.children, (child, idx) => {
						return idx === this.state.currentItem ? child : null
					})}
				</div>
			</div>
		)
	}
}

const TabsCarouselSlide = props => (
	<div className="Tabs-carousel-slide">
		{props.children}
	</div>
)

export { TabsCarousel, TabsCarouselSlide,	}
